import { render, staticRenderFns } from "./ViewDetail.vue?vue&type=template&id=6d06c219&"
import script from "./ViewDetail.vue?vue&type=script&lang=js&"
export * from "./ViewDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports